import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { MetricDefinition } from '../../../ts/models/ContentDefinitions';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { SubspaceName } from '../../state/SpaceInfo';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { Subspace, TabbedSpace } from '../TabbedSpace';

export interface MetricsSpaceOwnProps extends ReactDirectiveProps{
  readonly telemetry: Telemetry;
}

export interface MetricsStateProps {
  readonly activeSubspaceName: SubspaceName;
  readonly urls: SpacesSiteUrls;
}

export interface MetricsDispatchProps { }

export type MetricsProps = MetricsSpaceOwnProps & MetricsStateProps & MetricsDispatchProps;

export class MetricsSpace extends React.PureComponent<MetricsProps> {

  public constructor(props: MetricsProps){
    super(props);
  }

  public render() {
    const subspaces: ReadonlyArray<Subspace> = [
      this.createSubspace('favorites', Messages.navigation_favorites()),
      this.createSubspace('all', Messages.all()),
      this.createSubspace('owned', Messages.ownedByMe())
    ];

    return <TabbedSpace
      subspaces={subspaces}
      activeSubspaceName={this.props.activeSubspaceName}
      urlForSubspace={(subspace: SubspaceName) => this.props.urls.exploreMetricsUrl(subspace) }
      mastheadElement={this.mastheadElement()}
      testIdPrefix={'metrics-tabbed-space'}
      spaceItemName={Messages.metrics()}
    />;
  }

  private createSubspace(name: SubspaceName, label: string): Subspace {
    return {
      name,
      tabLabel: label,
      shouldRenderTabContentCount: false,
      renderContent: () => this.metricsExplorer(),
    };
  }

  private metricsExplorer(): JSX.Element {
    return <div className={ SpaceContainerStyles.SubplaceArea }>
      <ConnectedExplorer
        angularContext={this.props.angularContext}
        supportedDisplayModes={MetricDefinition.supportedDisplayModes}
        toolbarProps = {{
          toolbarVisibility: 'enabled',
          supportFilterPanel: true,
          hideSelection: false
        }}
        telemetry={this.props.telemetry}
        hideSelectionAndActionMenu={false}
      />
    </div>;
  }

  private mastheadElement(): React.ReactNode {
    return <div className={ ExplorerStyles.SpaceHeaderContent }>
      <div className={ ExplorerStyles.SpaceHeaderText }>{Messages.metrics()}</div>
    </div>;
  }
}
